import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-maintenance',
  templateUrl: './maintenancebroker.component.html',
  styleUrls: ['./maintenancebroker.component.scss']
})
export class MaintenanceComponentBroker  {

  constructor() { }

  ngOnInit(): void {
  }
}
